_ = require 'underscore'
assert = require 'lib/assert'
Backgrounds = require 'data/backgrounds'
BoardDisplayHelpers = require 'views/internal/board-display-helpers'
CardView = require 'views/card/card-view'
Controller = require 'controller'
l = require 'lib/localize'
permsTemplate = require 'views/templates/board_header_permissions'
template = require 'views/templates/member_cards_board'
Util = require 'lib/util'
View = require 'view'

module.exports = class MemberCardsBoardsSectionView extends View
  className: 'window-module'

  initialize: ({ @cards }) ->
    assert @cards.length > 0

  events: ->
    'click': (e) ->
      if @$(e.target).closest('a').length
        # We clicked on a link, e.g. to the team
        return
      Controller.navigate(Controller.getBoardUrl(@model), { trigger: true })

  render: ->
    orgData =
      if (org = @model.getOrganization())?
        url: org.get('url')
        name: org.get('displayName')

    lists = _.groupBy @cards, (card) -> card.get('idList')

    @$el.html(template({
      name: @model.get('name')
      url: @model.get('url')
      permissionLevel: @model.get('prefs').permissionLevel
      starred: @model.isStarred()
      org: orgData
      lists: @model.listList.chain()
        .filter (list) -> lists[list.id]
        .map (list) ->
          id: list.id
          name: list.get('name')
        .value()
    }))

    $perm = @$('.js-permission-level')
    data =
      permIconClass: BoardDisplayHelpers.getPermLevelIconClassForBoard(@model)
      permText: l(['board perms', @model.getPermLevel(), 'name'])
    $perm.html permsTemplate(data)

    prefs = @model.get('prefs')
    $board = @$('.js-board')

    if prefs.backgroundColor?
      hexcolor = @model.getClientBackgroundColor(prefs.background)

      $board.css
        'background-color': hexcolor

    else
      if Backgrounds.hasOwnProperty(prefs.background)
        # Special handling for our default backgrounds, to avoid using the
        # really huge versions
        url = Util.smallestPreviewBiggerThan(
          prefs.backgroundImageScaled,
          640,
          480
        )?.url ? prefs.backgroundImage
      else
        url = prefs.backgroundImage

      if prefs.backgroundTile
        smallUrl = url
      else
        smallUrl =
          Util.smallestPreviewBiggerThan(
            prefs.backgroundImageScaled
            64
            64
          )?.url ? prefs.backgroundImage


      $board.addClass('body-custom-board-background')

      if prefs.backgroundTile
        $board.addClass('body-custom-board-background-tiled')

      brightness = prefs.backgroundBrightness

      switch brightness
        when 'light'
          $board
          .addClass('body-light-board-background')
        when 'dark'
          $board
          .addClass('body-dark-board-background')

      $board
      .css
        'background-image': "url(\"#{url}\")"

    _.each @$('.js-list'), (el) =>
      $list = @$(el)
      idList = $list.attr('data-idList')

      subviews = _.chain(lists[idList])
        .sortBy (card) -> card.get('pos')
        .map (card) =>
          @subview(CardView, card)
        .value()

      @appendSubviews subviews, $list
    @



// WEBPACK FOOTER //
// ./app/scripts/views/member/member-cards-boards-section-view.coffee